import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

import ScriptFlowPreviousNavButton from 'common/ScriptFlowPreviousNavButton';
import ScriptFlowNextNavButton from 'common/ScriptFlowNextNavButton';
import SelectedLayersTracker from 'manual/SelectedLayersTracker';

const baseString = 'vra-script-flow-step-footer';
const classString = classNames({
  [`${baseString}`]: true
});

const ScriptFlowStepFooter = ({
  canGoBack,
  canGoForward,
  isAdvancedScripting,
  isExperimentScripting,
  isFinalStep,
  isMultiLayerEnabled,
  onClickBack,
  onClickForward
}) => {
  const classStringNav = classNames({
    [`${baseString}__nav`]: true,
    ['vra-advanced-final-footer']: isAdvancedScripting && isFinalStep
  });
  return (
    <section className={classString}>
      <nav className={classStringNav}>
        {isMultiLayerEnabled ? <SelectedLayersTracker /> : null}
        <ScriptFlowPreviousNavButton
          canGoBack={canGoBack}
          onClickBack={onClickBack}
        />
        <ScriptFlowNextNavButton
          canGoForward={canGoForward}
          isExperimentScripting={isExperimentScripting}
          isFinalStep={isFinalStep}
          onClickForward={onClickForward}
        />
      </nav>
    </section>
  );
};
ScriptFlowStepFooter.propTypes = {
  canGoBack: propTypes.bool.isRequired,
  canGoForward: propTypes.bool.isRequired,
  isAdvancedScripting: propTypes.bool,
  isExperimentScripting: propTypes.bool,
  isFinalStep: propTypes.bool.isRequired,
  isMultiLayerEnabled: propTypes.bool.isRequired,
  onClickBack: propTypes.func.isRequired,
  onClickForward: propTypes.func.isRequired
};
export default ScriptFlowStepFooter;
